// import "./new.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// import { halfleaveformInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const isImage = (file) => file && file.type.startsWith("image/");
// const isPDF = (file) => file && file.type === "application/pdf";

// const HalfLeaveFormNew = ({ title }) => {
//   const navigate = useNavigate();
//   const [file, setFile] = useState(null);
//   const [filePreview, setFilePreview] = useState("");
//   const [inputValues, setInputValues] = useState({
//     status: 1, // Default status to active
//     type: 0, // Default type to half leave
//   });
//   const [token] = useState(localStorage.getItem("token"));
//   const [minEndDate, setMinEndDate] = useState("");

//   const redirectToLogin = () => {
//     toast.warning("Please login first to access this page", {
//       autoClose: 1000,
//       onClose: () => (window.location.href = "/"),
//     });
//   };

//   const validateTime = (dateTimeString) => {
//     if (!dateTimeString) return false;
//     const date = new Date(dateTimeString);
//     const hours = date.getHours();
//     return hours >= 16 && hours <= 21; // 4 PM to 9 PM
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     // Special handling for datetime fields
//     if (name === "start_date_time") {
//       if (!validateTime(value)) {
//         toast.error("Leave time must be between 4 PM to 9 PM");
//         return;
//       }
//       setMinEndDate(value); // Set minimum end date to start date
//       setInputValues({
//         ...inputValues,
//         [name]: value,
//         end_date_time: value, // Set end date same as start date for half leave
//       });
//       return;
//     }

//     if (name === "end_date_time") {
//       if (!validateTime(value)) {
//         toast.error("Leave time must be between 4 PM to 9 PM");
//         return;
//       }
//       if (
//         inputValues.start_date_time &&
//         new Date(value) < new Date(inputValues.start_date_time)
//       ) {
//         toast.error("End time cannot be before start time");
//         return;
//       }
//     }

//     setInputValues({
//       ...inputValues,
//       [name]: value,
//     });
//   };

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (!selectedFile) return;

//     if (!isImage(selectedFile) && !isPDF(selectedFile)) {
//       toast.error("Please upload an image (JPEG, PNG) or PDF file");
//       return;
//     }

//     setFile(selectedFile);
//     setFilePreview(
//       isImage(selectedFile)
//         ? URL.createObjectURL(selectedFile)
//         : "/images/pdf_icon.png"
//     );
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!file) {
//       toast.error("Please upload a leave form file");
//       return;
//     }

//     if (!inputValues.start_date_time || !inputValues.end_date_time) {
//       toast.error("Please select both start and end times");
//       return;
//     }

//     const formData = new FormData();
//     const adminData = JSON.parse(localStorage.getItem("admindata"));

//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("student_id", localStorage.getItem("student_id"));
//     formData.append("user_id", adminData.id);
//     formData.append("reason", inputValues.reason);
//     formData.append("start_date_time", inputValues.start_date_time);
//     formData.append("end_date_time", inputValues.end_date_time);
//     formData.append("type", 0); // 0 for half leave
//     formData.append("logo", file);
//     formData.append("status", inputValues.status);

//     const toastId = toast.loading("Submitting half leave form...");

//     try {
//       const response = await fetch(`${serverUrl}/student/add_leave_form`, {
//         method: "POST",
//         body: formData,
//       });

//       const data = await response.json();

//       if (data.code >= 400) {
//         toast.update(toastId, {
//           render: data.message || "Failed to submit half leave form",
//           type: "error",
//           isLoading: false,
//           autoClose: 5000,
//         });
//         return;
//       }

//       toast.update(toastId, {
//         render: "Half leave form submitted successfully!",
//         type: "success",
//         isLoading: false,
//         autoClose: 1000,
//       });

//       // Reset form
//       setFile(null);
//       setFilePreview("");
//       setInputValues({
//         status: 1,
//         type: 0,
//       });

//       setTimeout(() => {
//         navigate("/student-attendance/half-leave-form");
//       }, 1000);
//     } catch (error) {
//       toast.update(toastId, {
//         render: "An error occurred while submitting the form",
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });
//       console.error(error);
//     }
//   };

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={3000} />
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="left">
//                 <div className="filePreview">
//                   {filePreview ? (
//                     <img
//                       src={filePreview}
//                       alt={
//                         isPDF(file) ? "Leave Form PDF" : "Leave Form Preview"
//                       }
//                       className="itemImg"
//                     />
//                   ) : (
//                     <img
//                       src="/images/upload_file.png"
//                       alt="Default File"
//                       className="itemImg"
//                     />
//                   )}
//                   {file && <p className="fileName">{file.name}</p>}
//                 </div>
//               </div>
//               <div className="right">
//                 <form onSubmit={handleSubmit}>
//                   <div className="formInput">
//                     <label htmlFor="file">
//                       Leave Form (Image/PDF):{" "}
//                       <DriveFolderUploadOutlinedIcon className="icon" />
//                     </label>
//                     <input
//                       type="file"
//                       id="file"
//                       accept="image/*,.pdf"
//                       onChange={handleFileChange}
//                       style={{ display: "none" }}
//                       required
//                     />
//                   </div>
//                   {halfleaveformInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       {input.fieldName === "status" ? null : (
//                         <>
//                           <label>{input.label}</label>
//                           <input
//                             type={input.type}
//                             placeholder={input.placeholder}
//                             name={input.fieldName}
//                             value={inputValues[input.fieldName] || ""}
//                             onChange={handleInputChange}
//                             required={input.fieldName !== "status"}
//                             min={
//                               input.fieldName === "end_date_time"
//                                 ? minEndDate
//                                 : undefined
//                             }
//                           />
//                         </>
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formSubmit">
//                     <button type="submit" style={{ float: "right" }}>
//                       Submit
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default HalfLeaveFormNew;




import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useNavigate } from "react-router-dom";
import { useState, useCallback } from "react";
import { halfleaveformInputs } from "../../formSource";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const FilePreviewContainer = styled('div')({
  position: 'relative',
  width: '100%',
  height: 200,
  borderRadius: 12,
  border: '2px dashed #e0e0e0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#fafafa',
  marginBottom: 20,
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  '&.drag-active': {
    borderColor: '#7451f8',
    backgroundColor: 'rgba(116, 81, 248, 0.05)',
  },
});

const PreviewImage = styled('img')({
  maxWidth: '100%',
  maxHeight: '100%',
  objectFit: 'contain',
});

const FileInfo = styled('div')({
  marginTop: 10,
  textAlign: 'center',
  '& .fileName': {
    fontWeight: 500,
    color: '#333',
    fontSize: 14,
    marginTop: 8,
    wordBreak: 'break-all',
    padding: '0 10px',
  },
  '& .fileSize': {
    color: '#757575',
    fontSize: 12,
  },
});

const RemoveButton = styled(Button)({
  position: 'absolute',
  top: 8,
  right: 8,
  minWidth: 30,
  height: 30,
  borderRadius: '50%',
  padding: 0,
});

const isImage = (file) => file && file.type.startsWith("image/");
const isPDF = (file) => file && file.type === "application/pdf";

const HalfLeaveFormNew = ({ title }) => {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState("");
  const [dragActive, setDragActive] = useState(false);
  const [inputValues, setInputValues] = useState({
    status: 1, // Default status to active
    type: 0, // Default type to half leave
  });
  const [minEndDate, setMinEndDate] = useState("");
  const token = localStorage.getItem("token");

  const redirectToLogin = () => {
    toast.warning("Please login first to access this page", {
      autoClose: 1000,
      onClose: () => (window.location.href = "/"),
    });
  };

  const validateTime = (dateTimeString) => {
    if (!dateTimeString) return false;
    const date = new Date(dateTimeString);
    const hours = date.getHours();
    return hours >= 16 && hours <= 21; // 4 PM to 9 PM
  };

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const selectedFile = e.dataTransfer.files[0];
      processFile(selectedFile);
    }
  }, []);

  const processFile = (selectedFile) => {
    if (!selectedFile) return;

    // Validate file type and size (max 5MB)
    if (!isImage(selectedFile) && !isPDF(selectedFile)) {
      toast.error("Please upload an image (JPEG, PNG) or PDF file");
      return;
    }

    if (selectedFile.size > 5 * 1024 * 1024) {
      toast.error("File size exceeds 5MB limit");
      return;
    }

    setFile(selectedFile);

    if (isImage(selectedFile)) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFilePreview(e.target.result);
      };
      reader.readAsDataURL(selectedFile);
    } else if (isPDF(selectedFile)) {
      setFilePreview("/images/pdf_icon.png");
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      processFile(e.target.files[0]);
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setFilePreview("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Special handling for datetime fields
    if (name === "start_date_time") {
      if (!validateTime(value)) {
        toast.error("Leave time must be between 4 PM to 9 PM");
        return;
      }
      setMinEndDate(value); // Set minimum end date to start date
      setInputValues({
        ...inputValues,
        [name]: value,
        end_date_time: value, // Set end date same as start date for half leave
      });
      return;
    }

    if (name === "end_date_time") {
      if (!validateTime(value)) {
        toast.error("Leave time must be between 4 PM to 9 PM");
        return;
      }
      if (
        inputValues.start_date_time &&
        new Date(value) < new Date(inputValues.start_date_time)
      ) {
        toast.error("End time cannot be before start time");
        return;
      }
    }

    setInputValues({
      ...inputValues,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error("Please upload a leave form file");
      return;
    }

    if (!inputValues.start_date_time || !inputValues.end_date_time) {
      toast.error("Please select both start and end times");
      return;
    }

    const formData = new FormData();
    const adminData = JSON.parse(localStorage.getItem("admindata"));

    formData.append("center_id", localStorage.getItem("center_id"));
    formData.append("student_id", localStorage.getItem("student_id"));
    formData.append("user_id", adminData.id);
    formData.append("reason", inputValues.reason);
    formData.append("start_date_time", inputValues.start_date_time);
    formData.append("end_date_time", inputValues.end_date_time);
    formData.append("type", 0); // 0 for half leave
    formData.append("logo", file);
    formData.append("status", inputValues.status);

    const toastId = toast.loading("Submitting half leave form...");

    try {
      const response = await fetch(`${serverUrl}/student/add_leave_form`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        toast.update(toastId, {
          render: data.message || "Failed to submit half leave form",
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
        return;
      }

      toast.update(toastId, {
        render: "Half leave form submitted successfully!",
        type: "success",
        isLoading: false,
        autoClose: 1000,
      });

      // Reset form
      setFile(null);
      setFilePreview("");
      setInputValues({
        status: 1,
        type: 0,
      });

      setTimeout(() => {
        navigate("/student-attendance/half-leave-form");
      }, 1000);
    } catch (error) {
      toast.update(toastId, {
        render: "An error occurred while submitting the form",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      console.error(error);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-right" autoClose={3000} />
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      <Grid item xs={12} className="formGridItem">
                        <FilePreviewContainer
                          className={dragActive ? "drag-active" : ""}
                          onDragEnter={handleDrag}
                          onDragOver={handleDrag}
                          onDragLeave={handleDrag}
                          onDrop={handleDrop}
                        >
                          {filePreview ? (
                            <>
                              {isPDF(file) ? (
                                <PreviewImage
                                  src="/images/pdf_icon.png"
                                  alt="Half Leave Form PDF"
                                />
                              ) : (
                                <PreviewImage
                                  src={filePreview}
                                  alt="Half Leave Form Preview"
                                />
                              )}
                              {file && (
                                <>
                                  <FileInfo>
                                    <div className="fileName">{file.name}</div>
                                    <div className="fileSize">
                                      {(file.size / 1024).toFixed(1)} KB
                                    </div>
                                  </FileInfo>
                                  <RemoveButton
                                    variant="contained"
                                    color="error"
                                    onClick={handleRemoveFile}
                                  >
                                    ×
                                  </RemoveButton>
                                </>
                              )}
                            </>
                          ) : (
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                p: 2,
                              }}
                            >
                              <CloudUploadIcon
                                sx={{ fontSize: 48, color: dragActive ? '#7451f8' : '#bdbdbd', mb: 1, transition: 'color 0.3s' }}
                              />
                              <Typography variant="body1" color="textSecondary">
                                {dragActive ? "Drop your file here" : "Drag & drop your file here or"}
                              </Typography>
                              <Button
                                component="label"
                                variant="outlined"
                                startIcon={<DriveFolderUploadOutlinedIcon />}
                                sx={{ mt: 2 }}
                              >
                                Browse Files
                                <VisuallyHiddenInput
                                  type="file"
                                  accept="image/*,.pdf"
                                  onChange={handleFileChange}
                                  required
                                />
                              </Button>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                sx={{ mt: 1 }}
                              >
                                (Supports JPG, PNG, PDF up to 5MB)
                              </Typography>
                            </Box>
                          )}
                        </FilePreviewContainer>
                      </Grid>

                      {halfleaveformInputs.map((input) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          key={input.id}
                          className="formGridItem"
                        >
                          <div className="formInput">
                            {input.fieldName === "status" ? null : (
                              <>
                                <label>{input.label}</label>
                                <input
                                  type={input.type}
                                  placeholder={input.placeholder}
                                  name={input.fieldName}
                                  value={inputValues[input.fieldName] || ""}
                                  onChange={handleInputChange}
                                  required={input.fieldName !== "status"}
                                  min={
                                    input.fieldName === "end_date_time"
                                      ? minEndDate
                                      : undefined
                                  }
                                />
                              </>
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/student-attendance/half-leave-form")}
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                        // disabled={!file}
                      >
                        Submit Form
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
    </ThemeProvider>
  );
};

export default HalfLeaveFormNew;